<template>
  <div class="saving-screen fixed" v-if="isLoading">
    <span>Sayfa hazırlanıyor, lütfen bekleyin....</span>
  </div>
  <div class="saving-screen fixed" v-if="isCreating">
    <span>PDFler hazırlanıyor, lütfen bekleyin....</span>
  </div>

  <filter-bar
    ref="filterBarRef"
    :show-first-row="true"
    :show-filter-button="true"
    filter-button-text="Filtre"
    :is-loading="isLoading || errorImages.length > 0"
    :show-dynamic-properties="true"
    @filter="onExportFilter"
    @property-change="onDynamicPropertyChange"
  >
    <template #first-row>
      <r-select
        v-model="selectedYearMonth"
        label="Yıl / Ay"
        :data="yearMonthOptions"
        txt="txt"
        val="val"
        width="14%"
        @change="onYearMonthChange"
      />
      <r-input v-model="realUrl" label="Sitede kullanılacak Url" width="26%" />
      <r-btn
        bgcolor="#ff1155"
        @click="copyHtml"
        :disabled="errorImages.length > 0"
      >
        HTML Kopyala
      </r-btn>
      <r-select
        v-if="store.state.usertype === 0 || store.state.usertype === 1"
        v-model="questPart"
        label="Soru Çeşidi"
        :data="questPartOptions"
        txt="txt"
        val="val"
        width="14%"
        @change="getQuests"
      />
      <r-select
        v-if="store.state.usertype === 2"
        v-model="catId"
        label="Kategoriler"
        :data="catList?.data || []"
        txt="title"
        val="id"
        width="14%"
        @change="GetCategoryQuestions"
        style="color: rgb(17, 17, 17)"
      >
        <template v-slot:itemtxt="{ data }">
          {{ data.id + "_" + data.title }}
        </template>
      </r-select>
      <r-select
        v-model="branchId"
        label="Branş"
        :data="branchOptions"
        txt="title"
        val="id"
        width="14%"
        style="color: rgb(17, 17, 17)"
        @change="onBranchChange"
      />
      <r-select
        v-model="subCategoryId"
        label="Alt Kategori"
        :data="subCategoryOptions"
        txt="title"
        val="id"
        width="14%"
        style="color: rgb(17, 17, 17)"
        :disabled="!branchId"
      />
    </template>

    <template #second-row>
      <r-select
        v-model="noteCategoryId"
        label="Kitap Türü"
        :data="noteCategoryOptions"
        txt="title"
        val="id"
        width="18%"
        @change="onNoteCategoryChange"
        style="color: rgb(17, 17, 17)"
      />
      <r-select
        v-model="noteId"
        v-model:selected="selectedNoteIds"
        :selectable="true"
        empty-text="Seçiniz"
        label="Kitap"
        :data="noteOptions"
        txt="name"
        val="id"
        width="22%"
        style="color: rgb(17, 17, 17)"
      />
      <r-input v-model="startQuestion" label="PDF Başlangıç" width="10%" />
      <r-input v-model="endQuestion" label="PDF Bitiş" width="10%" />
    </template>

    <template #actions>
      <r-btn
        bgcolor="#ff9800"
        class="r-ml-8"
        @click="clearDynamicFilters"
        :disabled="isLoading || errorImages.length > 0"
      >
        Dinamik Filtreyi Temizle
      </r-btn>
    </template>
  </filter-bar>
  <r-flex class="r-mb-16 page-header-C">
    <div class="page-header-C-inner">
      <h3 class="page-header-C-title">Referanslar</h3>
      <div class="page-header-C-right">
        <r-select
          v-model="exportContentType"
          label="Çıktı içeriği"
          :data="exportContentTypeOptions"
          txt="txt"
          val="val"
          width="220px"
          style="color: rgb(17, 17, 17)"
        />
        <r-btn
          bgcolor="#aa6600"
          @click="createPDF"
          :disabled="!isExportTypeSelected || errorImages.length > 0"
        >
          PDF Oluştur
        </r-btn>
        <r-btn
          bgcolor="#0a7"
          @click="createPDFSequential"
          :disabled="!isExportTypeSelected || errorImages.length > 0"
        >
          PDF Oluştur (Sıralı)
        </r-btn>
        <r-btn
          bgcolor="#aa6600"
          @click="createSeperatePDF"
          :disabled="!isExportTypeSelected || errorImages.length > 0"
        >
          Parçalı PDF Oluştur
        </r-btn>
        <r-btn
          bgcolor="#6c757d"
          @click="openPdfColorSettings"
          :disabled="!isExportTypeSelected"
        >
          PDF Ayarları
        </r-btn>
      </div>
    </div>
  </r-flex>
  <!-- Referans kitapları: branşa göre gruplu checkbox -->
  <r-flex
    v-if="loaded && referenceBookGroups.length > 0"
    class="export-header-extra-row r-mb-8"
    align="center"
    style="flex-wrap: wrap; gap: 10px 16px;"
  >
    <span class="export-branch-label">Referans kitabı (branşa göre):</span>
    <div
      v-for="group in referenceBookGroups"
      :key="group.branch"
      class="export-book-group"
    >
      <div class="export-book-group-title">{{ group.branch }}</div>
      <div class="export-book-group-items">
        <label
          v-for="book in group.books"
          :key="book.key"
          class="export-branch-check"
        >
          <input
            type="checkbox"
            :value="book.key"
            v-model="selectedReferenceBookKeys"
          />
          <span>{{ book.name }}</span>
        </label>
      </div>
    </div>
  </r-flex>
  <r-flex v-else class="export-header-extra-row r-mb-8"></r-flex>
  <r-flex>
    <h4 v-if="errorImages.length > 0" class="txt-error">
      PDF sayfalardaki resimlerin tamamı yüklenemedi. Lütfen kontrol edip tekrar
      export etmeyi deneyin. Etkilenen Sayfalar: {{ errorImages }}
    </h4>
  </r-flex>
  <r-flex v-if="!loaded" class="pdf-range-info-block r-mb-16">
    <div class="pdf-range-info-inner">
      <strong>Soru numarası aralığı</strong>
      <p>
        <strong>PDF Başlangıç</strong> ve <strong>PDF Bitiş</strong> alanları,
        hangi soru numaralarının listeleneceğini belirler.
      </p>
      <p>
        Bir sınavda soru numaraları genelde <strong>1–200</strong> gibi geniş
        bir aralıktadır. Ancak <strong>Branş</strong> veya
        <strong>Alt Kategori</strong> seçtiğinizde, o branşa ait sorular sınav
        içinde yalnızca belirli bir aralıkta yer alır (örneğin Anatomi 1–13,
        Fizyoloji 14–26).
      </p>
      <p>
        <strong>Örnek:</strong> 50–100 aralığını girip branş olarak
        <strong>Anatomi</strong> seçerseniz, Anatomi soruları 1–13 aralığında
        olduğu için listede hiçbir soru bulunamaz. Sonuç almak için aralığın,
        seçtiğiniz branşın soru numaralarını kapsaması gerekir.
      </p>
      <p>
        Mümkünse <strong>1–200</strong> gibi geniş bir aralık kullanın veya
        branş/alt kategoriye göre doğru aralığı girin. Filtreleri seçip
        <strong>Filtre</strong> butonuna basarak listeyi getirin.
      </p>
    </div>
  </r-flex>
  <r-flex v-if="loaded">
    <r-flex flx="7" align="center" class="all-reference-pages" v-if="loaded">
      <template v-for="(questionRef, m) in exportableList" :key="m">
        <references-pages
          :pagedata="getReferencesBySelectedBooks(questionRef.references)"
          :qtype="questionType(questionRef.question)"
          :question="questionRef.question"
          :imagelist="imagesList['list' + questionRef.question.examNumber]"
          :export-content-type="exportContentTypeVal"
          v-model:imagesloaded="pageImagesLoaded"
        />
      </template>
    </r-flex>
    <div
      class="export-question-C"
      style="width: 100%; display: flex; flex-direction: column"
    >
      <template v-for="(quest, i) in exportableList" :key="i">
        <div style="width: 100%; margin-bottom: 16px">
          <!-- Orijinal soru -->
          <template v-if="exportContentTypeVal === 'original'">
            <div style="display: flex" v-if="quest.question.isCase">
              <strong>{{ quest.question.examNumber }}.</strong>
              <div style="display: flex" class="r-mb-8">
                <div v-html="quest.question.case"></div>
              </div>
            </div>
            <div style="display: flex">
              <strong v-if="!quest.question.isCase"
                >{{ quest.question.examNumber }}.</strong
              >
              <div v-html="quest.question.detail"></div>
              <br />
            </div>
            <div
              style="display:flex;flex-direction:column;padding-bottom:12px;"
            >
              <template
                v-for="(choice, j) in quest.question.choiceList"
                :key="j"
              >
                <div
                  :style="{
                    display: 'flex',
                    color:
                      store.state.choices[j] === quest.question.answer
                        ? getPdfColor('correctAnswer')
                        : ''
                  }"
                >
                  <p style="width: auto; width: 20px">
                    {{ store.state.choices[j] }})
                  </p>
                  <div v-html="choice"></div>
                </div>
              </template>
            </div>
            <div v-if="quest.question.answer">
              <strong>Doğru Cevap:</strong> {{ quest.question.answer }}
            </div>
          </template>
          <!-- Soru kökü ve çözümü -->
          <template v-else-if="exportContentTypeVal === 'stem_solution'">
            <div style="display: flex">
              <strong>{{ quest.question.examNumber }}.</strong>
              <div
                v-html="
                  quest.question.detailModifield ||
                    quest.question.description ||
                    '—'
                "
              ></div>
            </div>
          </template>
          <!-- Organik soru -->
          <template v-else-if="exportContentTypeVal === 'organic'">
            <div style="display: flex" v-if="quest.question.myOriginalCase">
              <strong>{{ quest.question.examNumber }}.</strong>
              <div class="r-mb-8" v-html="quest.question.myOriginalCase"></div>
            </div>
            <div style="display: flex">
              <strong>{{ quest.question.examNumber }}.</strong>
              <div v-html="quest.question.myOriginalDetail || '—'"></div>
            </div>
            <div
              style="display:flex;flex-direction:column;padding-bottom:12px;"
            >
              <template
                v-for="(choice, j) in [
                  quest.question.myOriginalA,
                  quest.question.myOriginalB,
                  quest.question.myOriginalC,
                  quest.question.myOriginalD,
                  quest.question.myOriginalE
                ]"
                :key="j"
              >
                <div
                  v-if="choice && String(choice).trim()"
                  :style="{
                    display: 'flex',
                    color:
                      (store.state.choices && store.state.choices[j]) ===
                      quest.question.myOriginalAnswer
                        ? getPdfColor('correctAnswer')
                        : ''
                  }"
                >
                  <p style="width: 20px">
                    {{
                      (store.state.choices && store.state.choices[j]) ||
                        "ABCDE"[j]
                    }})
                  </p>
                  <div v-html="choice"></div>
                </div>
              </template>
            </div>
            <div v-if="quest.question.myOriginalAnswer">
              <strong>Doğru Cevap:</strong>
              {{ quest.question.myOriginalAnswer }}
            </div>
          </template>
          <!-- Varsayılan: orijinal -->
          <template v-else>
            <div style="display: flex" v-if="quest.question.isCase">
              <strong>{{ quest.question.examNumber }}.</strong>
              <div class="r-mb-8" v-html="quest.question.case"></div>
            </div>
            <div style="display: flex">
              <strong v-if="!quest.question.isCase"
                >{{ quest.question.examNumber }}.</strong
              >
              <div v-html="quest.question.detail"></div>
              <br />
            </div>
            <div
              style="display:flex;flex-direction:column;padding-bottom:12px;"
            >
              <template
                v-for="(choice, j) in quest.question.choiceList"
                :key="j"
              >
                <div
                  :style="{
                    display: 'flex',
                    color:
                      store.state.choices[j] === quest.question.answer
                        ? getPdfColor('correctAnswer')
                        : ''
                  }"
                >
                  <p style="width: 20px">{{ store.state.choices[j] }})</p>
                  <div v-html="choice"></div>
                </div>
              </template>
            </div>
            <div v-if="quest.question.answer">
              <strong>Doğru Cevap:</strong> {{ quest.question.answer }}
            </div>
          </template>
          <div
            style="display:flex;flex-direction:column;"
            v-if="getReferencesBySelectedBooks(quest.references).length > 0"
          >
            <template
              v-for="(ref, k) in getReferencesBySelectedBooks(
                quest.references
              )"
              :key="k"
            >
              <div style="display: flex">
                <span :style="{ color: getPdfColor('referenceLabel') }">
                  Referans: &nbsp;
                </span>
                <span :style="{ color: getPdfColor('referenceTitle') }">
                  {{ ref.lessonNoteName || ref.title || ""
                  }}{{ refBranchLabel(ref) }}&nbsp;
                </span>
                <a
                  :style="{ color: getPdfColor('referenceLink') }"
                  target="_blank"
                  :href="DownloadPdfUrl(quest, ref)"
                >
                  Referansları görüntülemek için tıklayın
                </a>
              </div>
            </template>
          </div>
          <r-btn
            @click="createPartPDF(i)"
            class="r-mt-8 r-mb-32"
            :disabled="errorImages.length > 0"
          >
            PDF Oluştur
          </r-btn>
        </div>
      </template>
    </div>
  </r-flex>
</template>
<script>
import { computed, nextTick, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import ReferencesPages from "../Referanslar/ReferencesPages";
import FilterBar from "@/components/FilterBar/FilterBar.vue";
import { makeUrl } from "@/mix/global.js";
import { getPdfColor, getPdfColors } from "@/utils/pdfColors.js";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
export default {
  components: {
    ReferencesPages,
    FilterBar
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const listData = ref({});
    const notesCatsList = ref({});
    const noteCategoryId = ref(null);
    const noteList = ref({});
    const noteId = ref(null);
    const selectedNoteIds = ref([]);
    const loaded = ref(false);
    const noReference = ref(false);
    const imagesList = ref({});
    const realUrl = ref("");
    const isCreating = ref(false);
    const isLoading = ref(false);
    const firstList = ref({});
    const listcnt = ref(0);
    const questPart = ref(0);
    const pageImagesLoaded = ref(true);
    const startQuestion = ref(1);
    const endQuestion = ref(100);
    const errorImages = ref([]);
    const imagesLoaded = ref(false);
    const pageImages = ref([]);
    const pdfImages = ref([]);
    const catId = ref(null);
    const catList = ref({});
    const branchId = ref(null);
    const branchList = ref({});
    const subCategoryId = ref(null);
    const subCategoryList = ref({});
    const questionCount = ref(0);
    const contentEl = ref(null);
    const exportContentType = ref(null);
    const exportContentTypeOptions = ref([
      { txt: "Seçiniz", val: null },
      { txt: "Orijinal soru", val: "original" },
      { txt: "Soru kökü ve çözümü", val: "stem_solution" },
      { txt: "Organik soru", val: "organic" }
    ]);
    const exportContentTypeVal = computed(() => {
      const v = exportContentType.value;
      return (v && typeof v === "object" ? v.val : v) || "original";
    });
    const isExportTypeSelected = computed(() => {
      const v = exportContentType.value;
      const val = v && typeof v === "object" ? v.val : v;
      return val != null && val !== "";
    });
    const questParts = ref([
      { txt: "Temel Bilimler", val: 1 },
      { txt: "Klinik Bilimler", val: 2 }
    ]);
    const yearMonthList = ref([]);
    const selectedYearMonth = ref(null);
    const workYear = ref("");
    const workMonth = ref("");
    const exportWorkFolder = computed(() => {
      if (!workYear.value || !workMonth.value) return "";
      return `${workYear.value}${String(workMonth.value).padStart(2, "0")}`;
    });
    const getReferenceImageProxyUrl = ({
      workFolder,
      imageRoot,
      categoryId,
      noteId,
      fileName
    }) => {
      const params = new URLSearchParams({
        workFolder: String(workFolder || ""),
        imageRoot: String(imageRoot || ""),
        categoryId: String(categoryId || ""),
        noteId: String(noteId || ""),
        fileName: String(fileName || "")
      });
      // Development modda proxy kullan (CORS için)
      const apiBase = process.env.NODE_ENV === "development" ? "/api/" : store.state.baseurl;
      return `${apiBase}references/getreferenceimage?${params.toString()}`;
    };
    const yearMonthOptions = computed(() => {
      const arr = Array.isArray(yearMonthList.value) ? yearMonthList.value : [];
      return arr.map(x => ({ txt: x, val: x }));
    });
    const questPartOptions = computed(() => {
      const base = questParts.value || [];
      return [{ txt: "Hepsi", val: null }, ...base];
    });
    const branchOptions = computed(() => {
      const arr =
        branchList.value && Array.isArray(branchList.value.data)
          ? branchList.value.data
          : [];
      return [{ title: "Hepsi", id: null }, ...arr];
    });
    const subCategoryOptions = computed(() => {
      const arr =
        subCategoryList.value && Array.isArray(subCategoryList.value.data)
          ? subCategoryList.value.data
          : [];
      return [{ title: "Hepsi", id: null }, ...arr];
    });
    const noteCategoryOptions = computed(() => {
      const arr =
        notesCatsList.value && Array.isArray(notesCatsList.value.data)
          ? notesCatsList.value.data
          : [];
      return [
        { title: "Seçiniz", id: null },
        { title: "Hepsi", id: -1 },
        ...arr
      ];
    });
    const noteOptions = computed(() => {
      const src = noteList.value || {};
      const arr = Array.isArray(src.data)
        ? src.data
        : Array.isArray(src.Data)
        ? src.Data
        : [];
      return arr;
    });
    const dynamicPropertyFilters = ref({});
    const filterBarRef = ref(null);
    const referenceImagesLoaded = () => {
      pageImages.value.forEach(img => {
        img.addEventListener("error", function() {
          if (
            errorImages.value.indexOf(img.getAttribute("data-imgquestion")) < 0
          )
            errorImages.value.push(img.getAttribute("data-imgquestion"));
        });
      });
    };
    // API'den gelen yapı: { data: { sorular: [...], referansBranslari: [...] } }
    const realList = computed(() => {
      const d = listData.value?.data ?? listData.value?.Data;
      return d?.sorular ?? d?.Sorular ?? (Array.isArray(d) ? d : []);
    });
    const selectedReferenceBookKeys = ref([]);
    const refBranchLabel = ref => {
      const items = ref.data || (Array.isArray(ref) ? ref : [ref]);
      const names = [
        ...new Set(items.map(r => r.branchName || r.BranchName).filter(Boolean))
      ];
      return names.length ? " (" + names.join(", ") + ")" : "";
    };
    const toReferenceBookKey = r => {
      const id = r?.lessonNoteId ?? r?.LessonNoteId ?? r?.noteId ?? r?.NoteId;
      if (id != null) return "id:" + id;
      const name = r?.lessonNoteName || r?.LessonNoteName || r?.title || r?.Title || "";
      return "name:" + name;
    };
    const referenceBookGroups = computed(() => {
      const groupMap = new Map();
      (realList.value || []).forEach(item => {
        (item?.references || []).forEach(r => {
          const branchName =
            r?.noteBranchName ||
            r?.NoteBranchName ||
            r?.branchName ||
            r?.BranchName ||
            "Diger";
          const key = toReferenceBookKey(r);
          const name =
            r?.lessonNoteName ||
            r?.LessonNoteName ||
            r?.title ||
            r?.Title ||
            "Adsiz kitap";
          if (!groupMap.has(branchName)) {
            groupMap.set(branchName, new Map());
          }
          const booksMap = groupMap.get(branchName);
          if (!booksMap.has(key)) {
            booksMap.set(key, { key, name });
          }
        });
      });
      return Array.from(groupMap.entries())
        .map(([branch, booksMap]) => ({
          branch,
          books: Array.from(booksMap.values()).sort((a, b) =>
            String(a.name).localeCompare(String(b.name), "tr")
          )
        }))
        .sort((a, b) => String(a.branch).localeCompare(String(b.branch), "tr"));
    });
    // İlk ekran açılırken tüm referans kitapları otomatik seçili (checked) gelsin
    watch(
      referenceBookGroups,
      groups => {
        if (Array.isArray(groups) && groups.length > 0) {
          const allKeys = groups.flatMap(g => (g.books || []).map(b => b.key));
          selectedReferenceBookKeys.value = Array.from(new Set(allKeys));
        } else {
          selectedReferenceBookKeys.value = [];
        }
      },
      { immediate: true }
    );
    // Kitap checkbox'ları değiştiğinde export için hazırlanan gizli sayfaları yeniden üret.
    // Aksi halde ekranda filtrelenmiş görünse bile export eski referanslarla kalabiliyor.
    watch(
      selectedReferenceBookKeys,
      async () => {
        if (!loaded.value) return;
        await nextTick();
        listForPdf();
      },
      { deep: true }
    );
    // Seçili kitaplara göre referans filtrele: unchecked kitaplar PDF/ekranda çıkmaz
    const getReferencesBySelectedBooks = references => {
      if (!Array.isArray(references)) return [];
      const selected = selectedReferenceBookKeys.value;
      if (!selected || selected.length === 0) return references;
      return references.filter(r => selected.includes(toReferenceBookKey(r)));
    };
    // Export hedef listesi: filtreden sonra referansı kalmayan soruları tamamen dışarıda bırak
    const exportableList = computed(() => {
      return (realList.value || []).filter(
        item => getReferencesBySelectedBooks(item?.references).length > 0
      );
    });
    const questionType = q => {
      if (store.state.usertype === 0) {
        if (parseInt(q.examNumber) <= store.state.tustemelq)
          return "Temel Bilimler";
        else return "Klinik Bilimler";
      } else if (store.state.usertype === 1) {
        if (parseInt(q.examNumber) <= store.state.dustemelq)
          return "Temel Bilimler";
        else return "Klinik Bilimler";
      } else if (store.state.usertype === 2) {
        return q.categoryName;
      }
    };
    const minQuest = computed(() => {
      const q = questPart.value;
      if (store.state.usertype === 0) {
        if (q == null) return 1;
        if (parseInt(q) === 1) return store.state.tustemelq + 1;
        return 1;
      }
      if (store.state.usertype === 1) {
        if (q == null) return 1;
        if (parseInt(q) === 1) return store.state.dustemelq + 1;
        return 1;
      }
      if (store.state.usertype === 2) return 1;
      return 1;
    });
    const maxQuest = computed(() => {
      const q = questPart.value;
      if (store.state.usertype === 0) {
        if (q == null) return store.state.tustotalq;
        if (parseInt(q) === 1) return store.state.tustotalq;
        return store.state.tustemelq;
      }
      if (store.state.usertype === 1) {
        if (q == null) return store.state.dustotalq;
        if (parseInt(q) === 1) return store.state.dustotalq;
        return store.state.dustemelq;
      }
      if (store.state.usertype === 2) return questionCount.value;
      return 100;
    });

    const newList = (list, quest) => {
      list.sort((a, b) => {
        return a.priority - b.priority;
      });
      imagesList.value["list" + quest.examNumber] = [];
      var newArr = [];
      var listKeys = [];
      var ind = 0;
      if (list.length > 0) {
        list.forEach(itm => {
          if (listKeys.indexOf(itm.noteCategoryName) === -1) {
            listKeys.push(itm.noteCategoryName);
            let notcat = notesCatsList.value.data.filter(v => {
              return v.id === itm.noteCategoryId;
            })[0];
            newArr.push({
              id: ind,
              title: itm.noteCategoryName,
              pagetitle: notcat.title,
              pagedesc: notcat.description,
              data: [itm]
            });
            imagesList.value["list" + quest.examNumber].push([]);
            ind++;
          } else {
            newArr[listKeys.indexOf(itm.noteCategoryName)].data.push(itm);
          }
        });
        newArr.forEach((itm, i) => {
          var subKeys = [];
          var indi = 0;
          itm.data1 = [];
          itm.data.forEach(dr => {
            if (subKeys.indexOf(dr.userId) === -1) {
              subKeys.push(dr.userId);
              itm.data1.push({
                id: indi,
                title: dr.username,
                userid: dr.userId,
                data: [dr]
              });

              indi++;
            } else {
              itm.data1[subKeys.indexOf(dr.userId)].data.push(dr);
            }
            dr.pid = i;
            delete itm.data;
          });
          itm.data1.forEach((dat, m) => {
            dat.data.forEach((pag, n) => {
              if (pag.pages.length > 0) {
                pag.pages[0].detail.forEach((drw, o) => {
                  if (drw.isImg) {
                    drw.iid = i;
                    drw.tid = m;
                    drw.pid = n;
                    drw.kid = o;
                    drw.url = getReferenceImageProxyUrl({
                      workFolder: exportWorkFolder.value,
                      imageRoot: `edited_ref_img_${store.state.usertype}`,
                      categoryId: quest.categoryId,
                      noteId: pag.lessonNoteId,
                      fileName: `${drw.fileName}.jpg`
                    });
                    imagesList.value["list" + quest.examNumber][i].push(drw);
                  }
                });
              }
            });
          });
        });
      } else {
        imagesList.value["list" + quest.examNumber].push([]);
      }
      imagesList.value = Object.assign({}, imagesList.value);
      list.splice(0, list.length, ...newArr);
      listcnt.value++;
    };

    const createPDF = async () => {
      if (isCreating.value) return;
      isCreating.value = true;
      try {
        const doc = new jsPDF("p", "px", [1000, 1415]);
        const elsAll = document.getElementsByClassName("pdf-screen-W-save");
        const els = Array.from(elsAll).filter(el => {
          const qn = parseInt(el.getAttribute("data-question"));
          return (
            qn >= parseInt(startQuestion.value) &&
            qn <= parseInt(endQuestion.value)
          );
        });
        console.log("[PDF_EXPORT] createPDF - filtered elements", {
          totalEls: elsAll.length,
          filteredEls: els.length,
          startQuestion: startQuestion.value,
          endQuestion: endQuestion.value
        });
        
        for (let i = 0; i < els.length; i++) {
          const el = els[i];
          const qn = el.getAttribute("data-question");
          console.log("[PDF_EXPORT] createPDF - capturing element", {
            index: i,
            question: qn
          });
          const canvas = await html2canvas(el, {
            scale: 2.535,
            scrollX: 0,
            scrollY: 0,
            width: 700,
            useCORS: true,
            allowTaint: false
          });
          const img = canvas.toDataURL("image/jpeg", 0.75);
          console.log("[PDF_EXPORT] createPDF - image ready", {
            index: i,
            question: qn,
            imgLength: img.length
          });
          doc.addImage(img, "JPEG", 0, 0, 1000, 1415);
          if (i !== els.length - 1) doc.addPage();
        }
        
        let docname =
          exportWorkFolder.value +
          "_" +
          store.state.usertype +
          "_" +
          startQuestion.value +
          "_" +
          endQuestion.value +
          ".pdf";
        if (store.state.usertype === 2)
          docname =
            exportWorkFolder.value +
            "_" +
            store.state.usertype +
            "_" +
            catId.value +
            "_" +
            startQuestion.value +
            "_" +
            endQuestion.value +
            ".pdf";
        console.log("[PDF_EXPORT] createPDF - saving document", {
          docname,
          totalPages: els.length
        });
        doc.save(docname);
      } catch (e) {
        console.error("createPDF error", e);
      } finally {
        isCreating.value = false;
      }
    };

    const createPDFSequential = async () => {
      if (isCreating.value) return; // Çift tıklama önleme
      isCreating.value = true;
      try {
        const doc = new jsPDF("p", "px", [1000, 1415]);
        const elsAll = document.getElementsByClassName("pdf-screen-W-save");
        const els = Array.from(elsAll).filter(el => {
          const qn = parseInt(el.getAttribute("data-question"));
          return (
            qn >= parseInt(startQuestion.value) &&
            qn <= parseInt(endQuestion.value)
          );
        });
        console.log("[PDF_EXPORT] createPDFSequential - filtered elements", {
          totalEls: elsAll.length,
          filteredEls: els.length,
          startQuestion: startQuestion.value,
          endQuestion: endQuestion.value
        });
        for (let i = 0; i < els.length; i++) {
          const el = els[i];
          const qn = el.getAttribute("data-question");
          console.log("[PDF_EXPORT] createPDFSequential - capturing element", {
            index: i,
            question: qn
          });
          const canvas = await html2canvas(el, {
            scale: 1.9,
            scrollX: 0,
            scrollY: 0,
            width: 700,
            useCORS: true,
            allowTaint: false
          });
          const img = canvas.toDataURL("image/jpeg", 0.75);
          console.log("[PDF_EXPORT] createPDFSequential - image ready (FULL)", {
            index: i,
            question: qn,
            imgLength: img.length,
            imgFull: img
          });
          doc.addImage(img, "JPEG", 0, 0, 1000, 1415);
          console.log("[PDF_EXPORT] createPDFSequential - addImage done", {
            index: i,
            question: qn
          });
          if (i !== els.length - 1) doc.addPage();
        }
        let docname =
          exportWorkFolder.value +
          "_" +
          store.state.usertype +
          "_" +
          startQuestion.value +
          "_" +
          endQuestion.value +
          ".pdf";
        if (store.state.usertype === 2)
          docname =
            exportWorkFolder.value +
            "_" +
            store.state.usertype +
            "_" +
            catId.value +
            "_" +
            startQuestion.value +
            "_" +
            endQuestion.value +
            ".pdf";
        console.log("[PDF_EXPORT] createPDFSequential - saving document", {
          docname,
          totalPages: els.length
        });
        doc.save(docname);
      } catch (e) {
        console.error("createPDFSequential error", e);
      } finally {
        isCreating.value = false;
      }
    };

    const createSeperatePDF = () => {
      if (isCreating.value) return; // Çift tıklama önleme
      isCreating.value = true;
      setTimeout(() => {
        var noarr = 0;
        var imgaC = {};
        var intaC = {};
        var nocnt = 0;
        var docnoarr = {};
        exportableList.value.forEach(async arr => {
          if (
            parseInt(arr.question.examNumber) >=
              parseInt(startQuestion.value) &&
            parseInt(arr.question.examNumber) <= parseInt(endQuestion.value)
          ) {
            const refs = getReferencesBySelectedBooks(arr.references);
            if (refs.length > 0) {
              refs.forEach((pag, j) => {
                const doc = new jsPDF("p", "px", [1000, 1415]);
                var els = document.getElementsByClassName(
                  "sep-page-save-" + arr.question.examNumber + "-" + j
                );
                var newels = [];
                els.forEach(el => {
                  if (
                    parseInt(el.getAttribute("data-question")) >=
                      parseInt(startQuestion.value) &&
                    parseInt(el.getAttribute("data-question")) <=
                      parseInt(endQuestion.value)
                  )
                    newels.push(el);
                });
                var cnt = 0;
                var imgCnt = 0;
                var imgC = {};
                var intC = {};
                newels.forEach(async (el, i) => {
                  await html2canvas(el, {
                    scale: 2.535,
                    scrollX: 0,
                    scrollY: 0,
                    width: 700,
                    useCORS: true,
                    allowTaint: false
                  }).then(function(canvas) {
                    imgC["im" + i] = canvas.toDataURL("image/jpeg");
                    intC["i" + i] = setInterval(() => {
                      if (imgC["im" + i] !== "") {
                        clearInterval(intC["i" + i]);
                        cnt++;
                      }
                    }, 500);
                  });
                });

                var saveImgInt = setInterval(() => {
                  if (cnt === newels.length) {
                    clearInterval(saveImgInt);
                    for (let e = 0; e < newels.length; e++) {
                      doc.addImage(imgC["im" + e], "JPEG", 0, 0);
                      imgCnt++;
                      if (imgCnt !== newels.length) doc.addPage();
                      delete imgC["im" + e];
                    }
                  }
                }, 1000);

                var int = setInterval(() => {
                  if (imgCnt === newels.length) {
                    clearInterval(int);
                    var docname =
                      exportWorkFolder.value +
                      "_" +
                      store.state.usertype +
                      "_" +
                      arr.question.examNumber +
                      "_" +
                      makeUrl(refTitleForPdf(pag)) +
                      ".pdf";
                    if (store.state.usertype === 2)
                      docname =
                        exportWorkFolder.value +
                        "_" +
                        store.state.usertype +
                        "_" +
                        catId.value +
                        "_" +
                        arr.question.examNumber +
                        "_" +
                        makeUrl(refTitleForPdf(pag)) +
                        ".pdf";

                    doc.save(docname);
                    isCreating.value = false;
                  }
                }, 1000);
              });
            } else if (arr.references.length > 0) {
              // Referanslar vardı ama hepsi seçili branşlarda değil; atla
            } else {
              noarr++;
              var el = document.getElementsByClassName(
                "sep-page-save-" + arr.question.examNumber + "-0"
              )[0];
              docnoarr["doc-" + arr.question.examNumber] = new jsPDF(
                "p",
                "px",
                [1000, 1415]
              );
              await html2canvas(el, {
                scale: 2.535,
                scrollX: 0,
                scrollY: 0,
                width: 700,
                useCORS: true,
                allowTaint: false
              }).then(function(canvas) {
                imgaC["im" + arr.question.examNumber] = canvas.toDataURL(
                  "image/jpeg"
                );
                intaC["i" + arr.question.examNumber] = setInterval(() => {
                  if (imgaC["im" + arr.question.examNumber] !== "") {
                    clearInterval(intaC["i" + arr.question.examNumber]);
                    delete intaC["i" + arr.question.examNumber];
                    docnoarr["doc-" + arr.question.examNumber].addImage(
                      imgaC["im" + arr.question.examNumber],
                      "JPEG",
                      0,
                      0
                    );
                    nocnt++;
                    delete imgaC["im" + arr.question.examNumber];
                  }
                }, 500);
                var inta = setInterval(() => {
                  if (nocnt === noarr) {
                    clearInterval(inta);

                    Object.keys(docnoarr).forEach(k => {
                      let examNum = k.split("-");
                      var docname =
                        exportWorkFolder.value +
                        "_" +
                        store.state.usertype +
                        "_" +
                        examNum[1] +
                        ".pdf";
                      if (store.state.usertype === 2)
                        docname =
                          exportWorkFolder.value +
                          "_" +
                          store.state.usertype +
                          "_" +
                          catId.value +
                          "_" +
                          examNum[1] +
                          ".pdf";
                      docnoarr[k].save(docname);
                      delete docnoarr[k];
                    });
                    isCreating.value = false;
                  }
                }, 1000);
              });
            }
          }
        });
      }, 50);
    };

    const refTitleForPdf = r => (r && (r.lessonNoteName || r.title)) || "";
    const DownloadPdfUrl = (q, r) => {
      const title = refTitleForPdf(r);
      if (store.state.usertype === 2) {
        return (
          realUrl.value +
          "/" +
          exportWorkFolder.value +
          "_" +
          store.state.usertype +
          "_" +
          catId.value +
          "_" +
          q.question.examNumber +
          "_" +
          makeUrl(title) +
          ".pdf"
        );
      } else {
        return (
          realUrl.value +
          "/" +
          exportWorkFolder.value +
          "_" +
          store.state.usertype +
          "_" +
          q.question.examNumber +
          "_" +
          makeUrl(title) +
          ".pdf"
        );
      }
    };
    const createPartPDF = async x => {
      isCreating.value = true;
      setTimeout(() => {
        const refs = getReferencesBySelectedBooks(
          exportableList.value[x].references
        );
        if (refs.length > 0) {
          refs.forEach((pag, j) => {
            const doc = new jsPDF("p", "px", [1000, 1415]);
            var els = document.getElementsByClassName(
                "sep-page-save-" + exportableList.value[x].question.examNumber + "-" + j
            );
            var cnt = 0;
            var imgCnt = 0;
            var imgC = {};
            var intC = {};
            els.forEach(async (el, i) => {
              await html2canvas(el, {
                scale: 2.535,
                scrollX: 0,
                scrollY: 0,
                width: 700,
                useCORS: true,
                allowTaint: false
              }).then(function(canvas) {
                imgC["im" + i] = canvas.toDataURL("image/jpeg");
                intC["i" + i] = setInterval(() => {
                  if (imgC["im" + i] !== "") {
                    clearInterval(intC["i" + i]);
                    cnt++;
                  }
                }, 500);
              });
            });
            var saveImgInt = setInterval(() => {
              if (cnt === els.length) {
                clearInterval(saveImgInt);
                for (let e = 0; e < els.length; e++) {
                  doc.addImage(imgC["im" + e], "JPEG", 0, 0);
                  imgCnt++;
                  if (imgCnt !== els.length) doc.addPage();
                  delete imgC["im" + e];
                }
              }
            }, 1000);
            var int = setInterval(() => {
              if (imgCnt === els.length) {
                clearInterval(int);
                var docname =
                  exportWorkFolder.value +
                  "_" +
                  store.state.usertype +
                  "_" +
                  exportableList.value[x].question.examNumber +
                  "_" +
                  makeUrl(refTitleForPdf(pag)) +
                  ".pdf";
                if (store.state.usertype === 2)
                  docname =
                    exportWorkFolder.value +
                    "_" +
                    store.state.usertype +
                    "_" +
                    catId.value +
                    "_" +
                    exportableList.value[x].question.examNumber +
                    "_" +
                    makeUrl(refTitleForPdf(pag)) +
                    ".pdf";
                doc.save(docname);
                isCreating.value = false;
              }
            }, 1000);
          });
        } else if (exportableList.value[x].references.length > 0) {
          // Referanslar vardı ama hepsi seçili branşlarda değil; PDF yok, atla
          isCreating.value = false;
        } else {
          var rdy = false;
          const doc = new jsPDF("p", "px", [1000, 1415]);
          var el = document.getElementsByClassName(
            "sep-page-save-" + exportableList.value[x].question.examNumber + "-0"
          )[0];
          html2canvas(el, {
            scale: 2.535,
            scrollX: 0,
            scrollY: 0,
            width: 700
          }).then(function(canvas) {
            var img = canvas.toDataURL("image/jpeg");
            var imgint = setInterval(() => {
              if (img !== "") {
                clearInterval(imgint);
                doc.addImage(img, "JPEG", 0, 0);
                rdy = true;
              }
            }, 500);
            var inta = setInterval(() => {
              if (rdy) {
                clearInterval(inta);
                var docname =
                  exportWorkFolder.value +
                  "_" +
                  store.state.usertype +
                  "_" +
                  exportableList.value[x].question.examNumber +
                  ".pdf";
                if (store.state.usertype === 2)
                  docname =
                    exportWorkFolder.value +
                    "_" +
                    store.state.usertype +
                    "_" +
                    catId.value +
                    "_" +
                    exportableList.value[x].question.examNumber +
                    ".pdf";

                doc.save(docname);
                isCreating.value = false;
              }
            }, 1000);
          });
        }
      }, 50);
    };
    const getQuests = async e => {
      if (!e) return;
      // Soru çeşidi değişince branş/alt-kategori seçimleri mutlaka "Hepsi" (null) olmalı
      const qpVal = e && typeof e === "object" ? e.val : e;
      questPart.value = qpVal !== undefined ? qpVal : null;

      branchId.value = null;
      subCategoryId.value = null;
      subCategoryList.value = { data: [] };

      const result = await getCatList(0);
      if (result && result.data && Array.isArray(result.data)) {
        const val = questPart.value;
        const filteredData =
          val == null
            ? result.data
            : result.data.filter(item => {
                const parentId =
                  item.parentId !== undefined ? item.parentId : item.ParentId;
                return parentId === val;
              });
        branchList.value = { data: filteredData };
      } else {
        branchList.value = { data: [] };
      }

      // Bazı durumlarda option listesi geldikten sonra eski branchId tekrar görünür olabiliyor
      await nextTick();
      branchId.value = null;
      subCategoryId.value = null;
    };
    const SetQuestionValue = () => {
      if (store.state.usertype === 0) {
        if (questPart.value == null) {
          startQuestion.value = 1;
          endQuestion.value = store.state.tustotalq ?? 200;
        } else if (parseInt(questPart.value) === 1) {
          startQuestion.value = 1;
          endQuestion.value = store.state.tustemelq ?? 100;
        } else {
          startQuestion.value = (store.state.tustemelq ?? 100) + 1;
          endQuestion.value = store.state.tustotalq ?? 200;
        }
      }
      if (store.state.usertype === 1) {
        if (questPart.value == null) {
          startQuestion.value = 1;
          endQuestion.value = store.state.dustotalq ?? 100;
        } else if (parseInt(questPart.value) === 1) {
          startQuestion.value = 1;
          endQuestion.value = store.state.dustemelq ?? 40;
        } else {
          startQuestion.value = (store.state.dustemelq ?? 40) + 1;
          endQuestion.value = store.state.dustotalq ?? 100;
        }
      }
      if (store.state.usertype === 2) {
        startQuestion.value = 1;
        endQuestion.value = questionCount.value;
      }
    };
    const getList = async (
      categoryId,
      branchIdParam,
      subCategoryIdParam,
      noteIdsParam
    ) => {
      // Kullanıcının girdiği değerleri kullan, yoksa computed değerleri kullan
      const minParsed =
        startQuestion.value && startQuestion.value.toString().trim() !== ""
          ? parseInt(startQuestion.value)
          : null;
      const maxParsed =
        endQuestion.value && endQuestion.value.toString().trim() !== ""
          ? parseInt(endQuestion.value)
          : null;
      const minVal =
        minParsed !== null && !isNaN(minParsed) ? minParsed : minQuest.value;
      const maxVal =
        maxParsed !== null && !isNaN(maxParsed) ? maxParsed : maxQuest.value;
      let params = {
        max: maxVal,
        min: minVal,
        workmonth: workMonth.value,
        workyear: workYear.value,
        isImg: true
      };

      // Dinamik property filtreleri: { [propDefId]: number[] } → düz listeye çevir
      const dynamicValues = dynamicPropertyFilters.value || {};
      const allValueIds = Object.values(dynamicValues)
        .reduce((acc, arr) => {
          if (Array.isArray(arr)) {
            return acc.concat(arr);
          }
          return acc;
        }, [])
        .filter((v, idx, arr) => arr.indexOf(v) === idx);

      // Dinamik property filtreleri
      if (allValueIds.length > 0) {
        params.dynamicPropertyValueIds = allValueIds.join(",");
      }

      let api = "references/getallreferences";
      if (store.state.usertype === 2 && categoryId !== undefined) {
        params.categoryId = categoryId;
        api = "references/getallreferencesbycategory";
      } else {
        // Soru çeşidi filtresi (sadece GetAllReferences için)
        if (questPart.value != null && questPart.value !== 0) {
          params.questPart = questPart.value;
        }
      }

      // Öncelik sırası: alt kategori > branş
      // Alt kategori seçilmişse, sadece alt kategoriyi gönder (daha spesifik)
      // Alt kategori seçilmemişse ama branş seçilmişse, branşı gönder
      if (subCategoryIdParam) {
        params.subCategoryId = subCategoryIdParam;
      } else if (branchIdParam) {
        params.branchId = branchIdParam;
      }

      // Kitap türü ve kitap filtreleri
      // Öncelik: noteIds (multi) > noteCategoryId
      const uniqueNoteIds = Array.from(new Set(noteIdsParam || []))
        .filter(v => v != null && v !== undefined && v !== 0);
      if (uniqueNoteIds.length > 0) {
        params.noteIds = uniqueNoteIds.join(",");
      } else if (noteCategoryId.value) {
        params.noteCategoryId = noteCategoryId.value;
      }
      let list = await store.dispatch("getDatas", {
        api: api,
        params: params
      });
      var noref = 0;
      firstList.value = list;
      const sorular =
        list?.data?.sorular ??
        list?.data?.Sorular ??
        (Array.isArray(list?.data) ? list.data : []);
      if (Array.isArray(sorular) && sorular.length > 0) {
        sorular.forEach(itm => {
          if (!(itm.references?.length || itm.References?.length)) noref++;
        });
        if (sorular.length === noref) noReference.value = true;
      }
      return list;
    };
    const GetCategoryQuestions = async d => {
      catId.value = d.id;
      questionCount.value = await getQuestionCount();
    };

    const onDynamicPropertyChange = payload => {
      // { propertyDefinitionId, selectedValues }
      if (!payload || payload.propertyDefinitionId == null) return;
      dynamicPropertyFilters.value = {
        ...dynamicPropertyFilters.value,
        [payload.propertyDefinitionId]: payload.selectedValues || []
      };
    };

    const clearDynamicFilters = () => {
      dynamicPropertyFilters.value = {};
      // FilterBar içindeki dinamik checkbox'ları da sıfırla
      if (
        filterBarRef.value &&
        typeof filterBarRef.value.resetDynamicProperties === "function"
      ) {
        filterBarRef.value.resetDynamicProperties();
      }
      // Listeyi dinamik filtreler olmadan yeniden yükle
      applyFilter();
    };

    const onExportFilter = async payload => {
      if (payload && payload.propertyValues) {
        dynamicPropertyFilters.value = payload.propertyValues;
      } else {
        dynamicPropertyFilters.value = {};
      }
      await applyFilter();
    };

    const applyFilter = async () => {
      loaded.value = false;
      imagesList.value = Object.assign({});
      isLoading.value = true;
      if (store.state.usertype === 0 || store.state.usertype === 1) {
        listData.value = await getList(
          undefined,
          branchId.value,
          subCategoryId.value,
          selectedNoteIds.value
        );
      } else if (store.state.usertype === 2) {
        if (!catId.value) {
          catList.value = await getCatList();
          catId.value = catList.value.data?.[0]?.id;
        }
        questionCount.value = await getQuestionCount();
        listData.value = await getList(
          catId.value,
          branchId.value,
          subCategoryId.value,
          selectedNoteIds.value
        );
      }
      const sorularArr =
        firstList.value?.data?.sorular ??
        firstList.value?.data?.Sorular ??
        (Array.isArray(firstList.value?.data) ? firstList.value.data : null);
      if (Array.isArray(sorularArr)) {
        sorularArr.sort((a, b) => {
          return (
            parseInt(a.question?.examNumber || a.Question?.ExamNumber) -
            parseInt(b.question?.examNumber || b.Question?.ExamNumber)
          );
        });
      }
      setTimeout(() => {
        listForPdf();
      }, 100);
    };
    const getCatList = async (pid = 0) => {
      let list = await store.dispatch("getDatas", {
        api: "categories/getsubcategories",
        params: { pid }
      });

      return list;
    };
    const getNoteCatsList = async () => {
      let list = await store.dispatch("getDatas", {
        api: "notes/getnotecategories"
      });
      return list;
    };
    const getNotesByCategory = async (categoryId, notCategoryId) => {
      let list = await store.dispatch("getDatas", {
        api: "notes/getnotesbycategoryandnotcatid",
        params: {
          categoryId: categoryId,
          isActive: true,
          notCategoryId: notCategoryId
        }
      });
      return list;
    };
    // Branş değiştiğinde alt kategori listesini güncelle; Alt Kategori 0. seçenek (Hepsi) olsun
    const onBranchChange = async e => {
      if (!e || e.id === undefined) return;
      branchId.value = e.id;

      if (e.id) {
        const result = await store.dispatch("getDatas", {
          api: "categories/getsubcategories",
          params: { pid: e.id }
        });
        if (result && result.data && Array.isArray(result.data)) {
          subCategoryList.value = { data: result.data };
        } else {
          subCategoryList.value = { data: [] };
        }
      } else {
        subCategoryList.value = { data: [] };
      }
      await nextTick();
      subCategoryId.value = null;

      // Kitap Türü Hepsi(-1) veya gerçek bir tür seçiliyse kitapları doldur.
      noteId.value = null;
      selectedNoteIds.value = [];
      if (branchId.value && noteCategoryId.value !== null) {
        const result = await getNotesByCategory(
          branchId.value,
          noteCategoryId.value
        );
        const dataArray =
          result?.data || result?.Data || (Array.isArray(result) ? result : []);
        noteList.value =
          dataArray && Array.isArray(dataArray) ? { data: dataArray } : { data: [] };
      } else {
        noteList.value = { data: [] };
      }
    };

    const onNoteCategoryChange = async e => {
      if (!e || e.id === undefined) return;
      noteCategoryId.value = e.id;
      noteId.value = null;
      selectedNoteIds.value = [];
      if (branchId.value && noteCategoryId.value !== null) {
        const result = await getNotesByCategory(
          branchId.value,
          noteCategoryId.value
        );
        const dataArray =
          result?.data || result?.Data || (Array.isArray(result) ? result : []);
        if (dataArray && Array.isArray(dataArray) && dataArray.length > 0) {
          noteList.value = { data: dataArray };
        } else {
          noteList.value = { data: [] };
        }
      } else {
        noteList.value = { data: [] };
      }
      // Filtre sadece "Filtre" butonu veya Yıl/Ay değişince uygulanır (Referans listesi ile aynı kural)
    };
    const loadYearMonths = async () => {
      const res = await store.dispatch("getDatas", {
        api: "settings/getmonthyear"
      });
      const arr = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res?.Data)
        ? res.Data
        : [];
      yearMonthList.value = Array.isArray(arr) ? arr : [];
    };
    const onYearMonthChange = async e => {
      if (!e || !e.val) return;
      selectedYearMonth.value = e.val;
      const parts = e.val.split("-");
      if (parts.length === 2) {
        const [year, month] = parts;
        workYear.value = year;
        workMonth.value = month;
      }
    };
    const getQuestionCount = async () => {
      let list = await store.dispatch("getDatas", {
        api: "categories/getquestioncount",
        params: {
          categoryid: catId.value
        }
      });
      return list.data;
    };
    const onPdfRangeInfo = () => {
      Swal.fire({
        icon: "info",
        title: "Soru numarası aralığı",
        html: `
          <p style="text-align: left; line-height: 1.6;">
            <strong>PDF Başlangıç</strong> ve <strong>PDF Bitiş</strong> alanları, hangi soru numaralarının listeleneceğini belirler.
          </p>
          <p style="text-align: left; line-height: 1.6;">
            Bir sınavda soru numaraları genelde <strong>1–200</strong> gibi geniş bir aralıktadır. Ancak <strong>Branş</strong> veya <strong>Alt Kategori</strong> seçtiğinizde, o branşa ait sorular sınav içinde yalnızca belirli bir aralıkta yer alır (örneğin Anatomi 1–13, Fizyoloji 14–26).
          </p>
          <p style="text-align: left; line-height: 1.6;">
            <strong>Örnek:</strong> 50–100 aralığını girip branş olarak <strong>Anatomi</strong> seçerseniz, Anatomi soruları 1–13 aralığında olduğu için listede hiçbir soru bulunamaz. Sonuç almak için aralığın, seçtiğiniz branşın soru numaralarını kapsaması gerekir.
          </p>
          <p style="text-align: left; line-height: 1.6;">
            Mümkünse <strong>1–200</strong> gibi geniş bir aralık kullanın veya branş/alt kategoriye göre doğru aralığı girin.
          </p>
        `,
        confirmButtonText: "Tamam",
        confirmButtonColor: "#1e88e5",
        width: "520px"
      });
    };
    const copyHtml = () => {
      var el = document.querySelector(".export-question-C");
      var cln = el.cloneNode(true);
      var div = document.createElement("div");
      div.appendChild(cln);
      var btns = div.getElementsByTagName("button");
      while (btns[0]) btns[0].parentNode.removeChild(btns[0]);
      div.innerHTML = div.innerHTML.replace(/<!--.*?-->/g, "");
      var txta = document.createElement("textarea");
      txta.value = div.innerHTML;
      txta.style.top = "0";
      txta.style.left = "100%";
      txta.style.position = "fixed";
      txta.style.opacity = "0";
      txta.style.width = "0";
      txta.style.height = "0";
      document.body.appendChild(txta);
      txta.focus();
      txta.select();
      document.execCommand("copy");
      document.body.removeChild(txta);
      cln.remove();
      div.remove();
    };
    const openPdfColorSettings = () => {
      router.push({ name: "pdfrenkayarlari" });
    };
    const listForPdf = () => {
      exportableList.value.sort((a, b) => {
        return (
          parseInt(a.question.examNumber) - parseInt(b.question.examNumber)
        );
      });
      listcnt.value = 0;
      var imgcnt = 0;
      pdfImages.value = [];
      exportableList.value.forEach(quest => {
        newList(
          getReferencesBySelectedBooks(quest.references),
          quest.question
        );
      });
      var int = setInterval(() => {
        if (listcnt.value === exportableList.value.length) {
          clearInterval(int);
          loaded.value = true;
          pdfImages.value = document.getElementsByClassName("pdf-img-n");
          pageImages.value = document.getElementsByClassName(
            "referans-img-tmp"
          );
        }
      }, 200);

      var imagesInt = setInterval(() => {
        if (pageImages.value.length > 0 || pdfImages.value.length === 0) {
          clearInterval(imagesInt);
          referenceImagesLoaded();
        }
      }, 200);

      var intimg = setInterval(() => {
        if (
          (loaded.value === true && pdfImages.value.length > 0) ||
          (loaded.value === true && noReference.value === true)
        ) {
          pdfImages.value.forEach(img => {
            if (img.complete) {
              imgcnt = imgcnt + 1;
            }
          });
        }
      }, 200);
      var intimgload = setInterval(() => {
        if (
          (pdfImages.value.length > 0 && imgcnt >= pdfImages.value.length) ||
          noReference.value === true
        ) {
          clearInterval(intimg);
          clearInterval(intimgload);
          isLoading.value = false;
        }
      }, 200);
    };
    const WindowResized = e => {
      contentEl.value.style.minHeight = e.target.innerHeight - 126 + "px";
    };
    onMounted(async () => {
      // PDF renklerini API'den yükle
      try {
        await getPdfColors();
        console.log("[PDF_EXPORT] PDF renkleri yüklendi");
      } catch (error) {
        console.error("[PDF_EXPORT] PDF renkleri yüklenirken hata:", error);
      }

      questPart.value = null;
      startQuestion.value = 1;
      endQuestion.value =
        store.state.usertype === 2
          ? 100
          : store.state.tustotalq ?? store.state.dustotalq ?? 100;
      // Yıl-Ay kombinasyonlarını yükle (en güncel dönem varsayılan)
      await loadYearMonths();
      if (yearMonthList.value.length > 0 && !selectedYearMonth.value) {
        selectedYearMonth.value = yearMonthList.value[0];
        const parts = String(selectedYearMonth.value).split("-");
        if (parts.length === 2) {
          workYear.value = parts[0];
          workMonth.value = parts[1];
        }
      }
      notesCatsList.value = await getNoteCatsList();
      const branchResult = await getCatList(0);
      if (
        branchResult &&
        branchResult.data &&
        Array.isArray(branchResult.data)
      ) {
        const val = questPart.value;
        const filteredData =
          val == null
            ? branchResult.data
            : branchResult.data.filter(item => {
                const parentId =
                  item.parentId !== undefined ? item.parentId : item.ParentId;
                return parentId === val;
              });
        branchList.value = { data: filteredData };
        branchId.value = null;
        subCategoryId.value = null;
        subCategoryList.value = { data: [] };
      } else {
        branchList.value = { data: [] };
        branchId.value = null;
        subCategoryId.value = null;
        subCategoryList.value = { data: [] };
      }
      if (store.state.usertype === 2) {
        catList.value = await getCatList();
        catId.value = catList.value.data?.[0]?.id;
      }
      SetQuestionValue();
      contentEl.value = document.getElementById("content-C");
      contentEl.value.style.minHeight = window.innerHeight - 126 + "px";
      window.addEventListener("resize", WindowResized);
    });
    return {
      store,
      listData,
      loaded,
      newList,
      createPDF,
      createPDFSequential,
      createSeperatePDF,
      createPartPDF,
      realList,
      exportableList,
      firstList,
      imagesList,
      questionType,
      makeUrl,
      realUrl,
      copyHtml,
      isCreating,
      isLoading,
      questPart,
      questParts,
      onExportFilter,
      onDynamicPropertyChange,
      clearDynamicFilters,
      filterBarRef,
      getQuests,
      pageImagesLoaded,
      startQuestion,
      endQuestion,
      errorImages,
      imagesLoaded,
      GetCategoryQuestions,
      catId,
      catList,
      branchId,
      branchList,
      branchOptions,
      subCategoryId,
      subCategoryList,
      subCategoryOptions,
      onBranchChange,
      DownloadPdfUrl,
      applyFilter,
      notesCatsList,
      noteCategoryId,
      noteCategoryOptions,
      noteList,
      noteOptions,
      noteId,
      selectedNoteIds,
      onNoteCategoryChange,
      getPdfColor,
      openPdfColorSettings,
      onPdfRangeInfo,
      yearMonthList,
      selectedYearMonth,
      yearMonthOptions,
      loadYearMonths,
      onYearMonthChange,
      questPartOptions,
      exportContentType,
      exportContentTypeOptions,
      exportContentTypeVal,
      isExportTypeSelected,
      referenceBookGroups,
      selectedReferenceBookKeys,
      refBranchLabel,
      getReferencesBySelectedBooks
    };
  }
};
</script>
<style>
.export-question-C {
  width: 100%;
}
.all-reference-pages {
  position: fixed;
  opacity: 0;
  left: 100%;
  top: 0;
}
.txt-error {
  background-color: crimson;
  color: #fff;
  padding: 16px;
  border-radius: 4px;
}
.page-header-C {
  width: 100%;
  padding-left: 0;
  padding-right: 0;
}
.page-header-C-inner {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}
.page-header-C-title {
  margin: 0;
  flex-shrink: 0;
}
.page-header-C-right {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  gap: 8px;
}
.page-header-C-right > * {
  flex-shrink: 0;
}
.export-header-extra-row {
  width: 100%;
  min-height: 32px;
  padding: 10px 16px;
  background-color: #f5f7fb;
  border-radius: 6px;
}
.export-branch-label {
  font-weight: 600;
  color: #333;
  margin-right: 8px;
}
.export-branch-check {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #444;
  white-space: nowrap;
}
.export-branch-check input {
  margin: 0;
  cursor: pointer;
}
.export-book-group {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border: 1px solid #dfe6f3;
  border-radius: 6px;
  background: #fff;
}
.export-book-group-title {
  font-weight: 600;
  color: #2d4a7a;
  white-space: nowrap;
}
.export-book-group-items {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 14px;
}
.pdf-range-info-block {
  width: 100%;
}
.pdf-range-info-inner {
  width: 100%;
  padding: 16px 20px;
  background: #e3f2fd;
  border: 1px solid #1e88e5;
  border-radius: 8px;
  color: #1565c0;
  font-size: 14px;
  line-height: 1.6;
  text-align: left;
}
.pdf-range-info-inner strong {
  display: block;
  margin-bottom: 8px;
  font-size: 15px;
  color: #0d47a1;
}
.pdf-range-info-inner p {
  margin: 0 0 10px 0;
}
.pdf-range-info-inner p:last-child {
  margin-bottom: 0;
}
</style>
